<template>
  <div>
    <CapSetting
      :cap-settings-type="capSettingType"
      :call-caps="callCaps"
      :settings-object-container="payoutCapacity"
      :cap-fields-translation="capFieldsTranslaction"
      :translation-dictionary="translactionDictionary"
      :enable-caps-label="enableCapsLabel"
      :enable-caps-tooltip="enableCapsTooltip"
      :additional-cap-settings="additionalCapSettings"
      :readonly="affiliateView"
      @change-call-caps="changeCallCaps"
      @change-settings-object-container="changeSettingsObjectContainer"
      @remove-caps="removeCaps()"
    />
  </div>
</template>

<script>
import nzToggle from '@/core/components/nzToggle/nzToggle';
import { capSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import CapSetting from '@/core/components/CapSetting/CapSetting';

export default {
  name: 'PayoutSettings',
  components: {
    nzToggle,
    CapSetting,
  },
  props: {
    callCaps: {
      type: Object,
      required: true,
    },
    payoutCapacity: {
      type: Object,
      required: true,
    },
    translactionDictionary: {
      type: Object,
      required: true,
    },
    enableCapsLabel: {
      type: String,
      required: true,
    },
    enableCapsTooltip: {
      type: String,
      required: true,
    },
    affiliateView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    capSettingType() {
      return capSettingsService.capSettingType.BOTH;
    },
    additionalCapSettings() {
      return [
        {
          key: 'concurrencyCap',
          capSettingType: capSettingsService.defaultCapSettingsType,
        },
      ];
    },
    capFieldsTranslaction() {
      return {
        allTimeSumCap: {
          label: 'PUBLISHER_PAYOUT_GLOBAL_SUM_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_GLOBAL_SUM_CAP_TT',
        },
        allTimeCap: {
          label: 'PUBLISHER_PAYOUT_GLOBAL_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_GLOBAL_CAP_TT',
        },
        monthlySumCap: {
          label: 'PUBLISHER_PAYOUT_MONTHLY_SUM_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_MONTHLY_SUM_CAP_TT',
        },
        monthlyCap: {
          label: 'PUBLISHER_PAYOUT_MONTHLY_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_MONTHLY_CAP_TT',
        },
        dailySumCap: {
          label: 'PUBLISHER_PAYOUT_DAILY_SUM_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_DAILY_SUM_CAP_TT',
        },
        dailyCap: {
          label: 'PUBLISHER_PAYOUT_DAILY_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_DAILY_CAP_TT',
        },
        hourlySumCap: {
          label: 'PUBLISHER_PAYOUT_HOURLY_SUM_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_HOURLY_SUM_CAP_TT',
        },
        hourlyCap: {
          label: 'PUBLISHER_PAYOUT_HOURLY_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_HOURLY_CAP_TT',
        },
        concurrencyCap: {
          label: 'PUBLISHER_PAYOUT_CONCURRENCY_CAP_LABEL',
          tooltip: 'PUBLISHER_PAYOUT_CONCURRENCY_CAP_TT',
        },
      };
    },
  },
  methods: {
    changeSettingsObjectContainer(value) {
      this.$emit('change-publisher-payout-capacity', {
        ...this.payoutCapacity,
        ...value,
      });
    },
    changeCallCaps(value) {
      this.$emit('change-call-caps', value);
    },
    removeCaps() {
      const callCapsCopy = { ...this.callCaps };
      Object.keys(callCapsCopy).forEach((key) => {
        callCapsCopy[key] = -1;
      });
      this.changeCallCaps(callCapsCopy);
    },
    initializePayoutCaps() {
      let payoutCapacityCopy = this.payoutCapacity || {};
      let callCapsCopy = this.callCaps || {};

      callCapsCopy = capSettingsService.initializeCallCaps(
        this.capSettingType,
        callCapsCopy,
        payoutCapacityCopy,
        this.additionalCapSettings
      );
      this.changeCallCaps(callCapsCopy);

      payoutCapacityCopy = capSettingsService.initializeCallCapSettings(
        this.capSettingType,
        payoutCapacityCopy,
        this.additionalCapSettings
      );
      this.changeSettingsObjectContainer(payoutCapacityCopy);
    },
  },
  created() {
    this.initializePayoutCaps();
  },
};
</script>

<style>
</style>